<template>
  <div>
    <div class="font-semibold mb-[30px] pr-6 text-gray-800">
      <span class="text-red-500"> Additional {{ discount }}% savings </span>
      by paying annually!
    </div>

    <div class="flex flex-col gap-y-2.5 mb-4">
      <PlanBillingOption
        v-for="plan in plans"
        v-model="selectedPlan"
        :key="plan.id"
        :plan="plan"
      />
    </div>

    <Button
      class="w-full mb-4"
      variant="primary"
      :size="isMobile ? 'lg' : 'md'"
      @click="handleContinue"
    >
      Continue
    </Button>

    <div class="text-[12px] leading-[20px] text-gray-500 text-center">
      Billed {{ billingCycle }}. Cancel anytime. Subscription is auto-renewable.
      By subscribing you agree to the Dacr
      <span class="inline-flex mr-1">
        <a
          href="/legal/terms"
          target="_blank"
          class="font-medium underline"
          @click="handleTermsClick"
        >
          Terms
        </a>
        ,
      </span>
      <span class="inline-flex">
        <a
          href="/legal/privacy"
          class="font-medium underline"
          @click="handlePrivacyClick"
        >
          Privacy Policy
        </a>
        ,
      </span>
      and
      <a
        href="/legal/payments"
        class="font-medium underline"
        @click="handlePricingClick"
      >
        Payment Terms
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { Button } from '@dacr/library'

import PlanBillingOption from '@/features/billing/components/PlanBillingOption.vue'
import { PlanPriceType, type Plan } from '@/shared/graphql/legacy/generated'
import { triggerDialogEvent } from '@/shared/dialogs/dialog'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'
import { useDevice } from '@/shared/composables/useDevice'

const props = defineProps<{
  plans: Plan[]
}>()

const { isMobile } = useDevice()
const webviewStore = useWebviewStore()

const selectedPlan = ref<Plan>(props.plans[1])

const discount = computed(() => (props.plans[0].items.length > 1 ? 25 : 40))

const billingCycle = computed(() => {
  const cycle = selectedPlan.value.items[0].prices.find(
    (price) => price.type === PlanPriceType.Subscription
  )?.details?.billingCycleType

  return cycle === 'month' ? 'monthly' : 'annually'
})

const openLegal = (e: MouseEvent, path: string) => {
  if (webviewStore.isActive) {
    e.preventDefault()
    webviewStore.postMessage({
      type: NativeActionsEnum.LinkOpen,
      data: `${import.meta.env.VITE_URL}${path}`,
    })
  }
}

const handleTermsClick = (e: MouseEvent) => openLegal(e, '/legal/terms')
const handlePrivacyClick = (e: MouseEvent) => openLegal(e, '/legal/privacy')
const handlePricingClick = (e: MouseEvent) => openLegal(e, '/legal/payments')

const handleContinue = () => {
  triggerDialogEvent('success', selectedPlan.value)
}
</script>
